import { useTranslation } from 'react-i18next';

import EditIcon from '@mui/icons-material/Edit';
import FilterListIcon from '@mui/icons-material/FilterList';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import ToolbarLayout from '../../components/ToolbarLayout';
import CsvIcon from '../../images/csv.svg?react';

const getActionButtonSx = (isMobile: any) => ({
    width: isMobile ? '100%' : 'auto',
    minWidth: isMobile ? 0 : '108px',
    height: isMobile ? '40px' : '48px',
    px: isMobile ? 1.5 : 2.5,
    borderRadius: '999px',
    backgroundColor: '#3F8EE8',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    textTransform: 'none',
    '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: '8px',
        flexShrink: 0,
    },
    '& .MuiButton-label': {
        whiteSpace: 'nowrap',
    },
    '&:hover': { backgroundColor: '#3F8EE8' },
});

function RecordsToolbarSection({
    isMobile,
    searchString,
    setSearchString,
    onSearch,
    onOpenExport,
    onOpenEdit,
    onOpenFilter,
}: any) {
    const { t } = useTranslation(undefined, { keyPrefix: 'Records' });
    return (
        <ToolbarLayout
            isMobile={isMobile}
            filterSlot={[
                <Button
                    key='filter'
                    variant='outlined'
                    onClick={onOpenFilter}
                    startIcon={<FilterListIcon />}
                    sx={{
                        ...getActionButtonSx(isMobile),
                        backgroundColor: '#fff',
                        color: '#3F8EE8',
                        borderColor: '#3F8EE8',
                        '&:hover': { backgroundColor: '#f0f7ff', borderColor: '#3F8EE8' },
                    }}
                    fullWidth={isMobile}
                >
                    {t('filter') || 'Filter'}
                </Button>,
            ]}
            actions={[
                <Button
                    key='export'
                    variant='contained'
                    startIcon={<CsvIcon className='svgIcon' />}
                    onClick={onOpenExport}
                    sx={getActionButtonSx(isMobile)}
                    fullWidth={isMobile}
                >
                    {t('export')}
                </Button>,
                <Button
                    key='edit'
                    variant='contained'
                    startIcon={<EditIcon className='svgIcon' />}
                    onClick={onOpenEdit}
                    sx={getActionButtonSx(isMobile)}
                    fullWidth={isMobile}
                >
                    {t('edit') || 'Edit'}
                </Button>,
            ]}
            searchInput={
                isMobile ? (
                    <TextField
                        label=''
                        variant='outlined'
                        InputProps={{ sx: { height: 40, paddingLeft: '15px' } }}
                        fullWidth
                        value={searchString}
                        onChange={(e: any) => setSearchString(e.target.value)}
                    />
                ) : (
                    <input
                        className='flex-1 cursor-text border-none bg-transparent text-base text-slate-700 placeholder:text-slate-400 focus:outline-none'
                        placeholder=''
                        value={searchString}
                        onChange={(e: any) => setSearchString(e.target.value)}
                    />
                )
            }
            searchButton={
                isMobile ? (
                    <Button
                        variant='text'
                        disableElevation
                        onClick={onSearch}
                        className='flex items-center justify-center'
                        sx={{
                            minWidth: '80px',
                            width: '80px',
                            height: '32px',
                            borderRadius: 0,
                            borderLeft: '2px solid #D4DCEB',
                            fontWeight: 600,
                            fontSize: '15px',
                            color: '#757575',
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            textTransform: 'none',
                            '&:hover': { backgroundColor: 'transparent', boxShadow: 'none' },
                        }}
                    >
                        {t('search')}
                    </Button>
                ) : (
                    <button
                        type='button'
                        className='ml-4 cursor-pointer text-sm font-semibold uppercase tracking-wide text-slate-700'
                        onClick={onSearch}
                    >
                        {t('search')}
                    </button>
                )
            }
        />
    );
}

export default RecordsToolbarSection;
